<template>
  <div>
    <p class="xPadding titleModal">
      {{ $t(`treatmentProgram.step2.title`) }}
    </p>
    <v-row class="xPadding">
      <v-col class="noYPadding">
        <VSelect
          v-model="data.controleInjection"
          :label="$t('treatmentProgram.step2.controlInjection')"
          :items="displayedUnits('controleInjection')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          datacy="controleInjection"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <Schedule
        v-if="data.controleInjection === 1"
        :model="data.schedule"
        @sendData="updateData"
      />
    </v-row>
    <v-row class="xPadding">
      <Probe
        v-if="data.controleInjection === 2"
        :model="data.probe"
        @sendData="updateData"
      />
    </v-row>
    <v-row class="xPadding">
      <Manual
        v-if="data.controleInjection === 3"
        :model="data.manual"
        objectKey="manual"
        @sendData="updateData"
      />
    </v-row>
    <v-row class="xPadding">
      <Time
        v-if="data.controleInjection === 4"
        :model="data.pourcentTime"
        @sendData="updateData"
      />
    </v-row>
    <v-row class="xPadding">
      <Manual
        v-if="data.controleInjection === 5"
        :model="data.other"
        objectKey="other"
        @sendData="updateData"
      />
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import Schedule from '@/components/forms/treatmentProgram/forms/sub-forms/Schedule';
import Probe from '@/components/forms/treatmentProgram/forms/sub-forms/Probe';
import Manual from '@/components/forms/treatmentProgram/forms/sub-forms/Manual';
import Time from '@/components/forms/treatmentProgram/forms/sub-forms/Time';
import moment from 'moment';

export default {
    name: 'InjectionMethod',
    components: {
        Schedule,
        Probe,
        Manual,
        Time,
    },
    props: {
        injectionMethod: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                capacity: {},
            },
        };
    },
    computed: {
        ...mapGetters([
            'treatmentProgramUnits',
        ]),
    },
    watch: {
        injectionMethod: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.injectionMethod) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData(model) {
            if (model.schedule?.cycleType?.start && model.schedule?.cycleType?.end) {
                const { start, end } = model.schedule.cycleType;

                const startDate = moment(start);
                const endDate = moment(end);

                const totalMinutes = endDate.diff(startDate, 'minutes');
                const hours = (totalMinutes / 60);
                const displayHours = Math.floor(hours);
                const minutes = (hours - displayHours) * 60;
                const displayMinutes = Math.round(minutes);
                // eslint-disable-next-line no-param-reassign
                model.schedule.cycleType.difference = `${ displayHours } : ${ displayMinutes }`;
            }
            this.data = { ...this.data, ...model };
            this.$emit('sendData', { injectionMethod: this.data });
        },
        displayedUnits(type) {
            return this.treatmentProgramUnits && this.treatmentProgramUnits[type]
                ? this.treatmentProgramUnits[type] : [];
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
.noYPadding {
    padding-bottom: 0px;
    padding-top: 0px;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
</style>
